'use client'

import type { SearchSuggestionsListProps } from '@maestro/commerce-blocks/components/search-bar/search.types'

import { useCallback } from 'react'

import { getSearchOptionId } from '@maestro/commerce-blocks/utils/search.utils'
import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType } from '@maestro/data-layer'
import { Link } from '@pearlconvert/ui/components/link'

export default function SearchSuggestionsList({
  title,
  items,
  onClick,
  activeOptionId,
}: SearchSuggestionsListProps) {
  const { publish } = useEventBusContext()

  const handleClickSuggestion = useCallback(
    (query: string, url: string) => {
      publish(EventType.SEARCH_SUGGESTIONS_CLICKED, {
        searchSection: title,
        searchTerm: query,
        clickUrl: url,
      })
      onClick(query)
    },
    [onClick, publish, title]
  )

  return (
    <div className="searchbar__suggestions-node">
      <h5 className="searchbar__suggestions-title">{title}</h5>
      <ul className="searchbar__suggestions-list">
        {items?.map((result, i) => {
          const searchUrl = `/search/?text=${result.query}`
          const optionId = getSearchOptionId(title, result.query, i)

          return (
            <li
              className="searchbar__suggestions-list-item"
              key={i}
              id={optionId}
              role="option"
              aria-selected={activeOptionId === optionId}
            >
              <Link
                className="searchbar__suggestions-list-link"
                href={searchUrl}
                tabIndex={-1}
                onClick={() => handleClickSuggestion(result.query, searchUrl)}
                onKeyDown={(e) =>
                  e.key === 'Enter' &&
                  handleClickSuggestion(result.query, searchUrl)
                }
                aria-label={`${title}: ${result.query}`}
              >
                {result.query}
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
